import { getLocale } from "../runtime";

const da_campaignexpired = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `For sent! Kampagnen er slut.`
};

const en_campaignexpired = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Too late! The campaign has ended.`
};

const es_campaignexpired = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `¡Demasiado tarde! La campaña ha terminado.`
};

const fi_campaignexpired = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Liian myöhäistä! Kampanja on päättynyt.`
};

const nb_campaignexpired = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `For sent! Kampanjen er slutt.`
};

const sv_campaignexpired = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `För sent! Kampanjen är slut.`
};

const campaignexpired = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_campaignexpired(inputs)
	if (locale === "en") return en_campaignexpired(inputs)
	if (locale === "es") return es_campaignexpired(inputs)
	if (locale === "fi") return fi_campaignexpired(inputs)
	if (locale === "nb") return nb_campaignexpired(inputs)
	if (locale === "sv") return sv_campaignexpired(inputs)
	return "campaignExpired";
};

export { campaignexpired as "campaignExpired" };